export default __webpack_public_path__ + "static/media/img12.b213e59e.png";